var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinculo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.889H7.7V4.26h2.8c1.197 0 2.17 1.004 2.17 2.239 0 1.033-.686 1.9-1.617 2.152l1.022 1.055A3.604 3.604 0 0014 6.5c0-1.993-1.568-3.611-3.5-3.611zm-.7 2.889H8.267l1.4 1.444H9.8V5.778zM0 .918l2.177 2.245C.903 3.698 0 4.991 0 6.5c0 1.993 1.568 3.611 3.5 3.611h2.8V8.74H3.5c-1.197 0-2.17-1.004-2.17-2.239 0-1.148.847-2.094 1.932-2.217l1.449 1.495H4.2v1.444h1.911L7.7 8.862v1.25h1.211L11.718 13l.882-.91L.889 0 0 .917z",
    fill: "red"
  })));
}
export default __webpack_public_path__ + "static/media/vinculo.070cef8b.svg";
export { SvgVinculo as ReactComponent };